var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2598_151635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 18.2601C12.4897 18.2601 12.8867 17.8632 12.8867 17.3735C12.8867 16.8838 12.4897 16.4868 12 16.4868C11.5103 16.4868 11.1133 16.8838 11.1133 17.3735C11.1133 17.8632 11.5103 18.2601 12 18.2601Z",
    fill: "#ED4650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.0736C11.8232 15.0736 11.6536 15.0033 11.5286 14.8783C11.4036 14.7533 11.3333 14.5837 11.3333 14.4069V6.4069C11.3333 6.23009 11.4036 6.06052 11.5286 5.9355C11.6536 5.81047 11.8232 5.74023 12 5.74023C12.1768 5.74023 12.3464 5.81047 12.4714 5.9355C12.5964 6.06052 12.6666 6.23009 12.6666 6.4069V14.4069C12.6666 14.5837 12.5964 14.7533 12.4714 14.8783C12.3464 15.0033 12.1768 15.0736 12 15.0736Z",
    fill: "#ED4650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22.6668C9.89032 22.6668 7.82803 22.0412 6.0739 20.8692C4.31978 19.6971 2.9526 18.0312 2.14527 16.0821C1.33793 14.133 1.1267 11.9883 1.53827 9.9192C1.94985 7.85007 2.96575 5.94946 4.45751 4.4577C5.94927 2.96594 7.84989 1.95003 9.91902 1.53846C11.9882 1.12688 14.1329 1.33812 16.0819 2.14545C18.031 2.95279 19.6969 4.31996 20.869 6.07408C22.0411 7.82821 22.6667 9.8905 22.6667 12.0002C22.6667 14.8291 21.5428 17.5423 19.5425 19.5426C17.5421 21.543 14.829 22.6668 12 22.6668ZM12 2.66683C10.154 2.66683 8.34952 3.21422 6.81466 4.23978C5.2798 5.26534 4.08353 6.72301 3.37711 8.42846C2.67069 10.1339 2.48586 12.0105 2.84599 13.821C3.20612 15.6315 4.09503 17.2945 5.40032 18.5998C6.70561 19.9051 8.36865 20.794 10.1791 21.1542C11.9896 21.5143 13.8663 21.3295 15.5717 20.623C17.2771 19.9166 18.7348 18.7203 19.7604 17.1855C20.7859 15.6506 21.3333 13.8461 21.3333 12.0002C21.3333 9.52481 20.35 7.15084 18.5996 5.4005C16.8493 3.65016 14.4753 2.66683 12 2.66683Z",
    fill: "#ED4650"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2598_151635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.50a8552d2d8e975c07652bb03fb818af.svg";
export { ForwardRef as ReactComponent };